import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, memo } from 'react';
import PropTypes from 'prop-types';
import SortByArrowUp from 'wix-ui-icons-common/system/SortByArrowUp';
import SortByArrowDown from 'wix-ui-icons-common/system/SortByArrowDown';
import { Animator } from 'wix-animations';
import classNames from 'classnames';
import defaultTo from 'lodash/defaultTo';
import { VariableSizeList as List } from 'react-window';
import { ScrollSyncPane } from 'react-scroll-sync';
import { TooltipCommonProps } from '../../common/PropTypes/TooltipCommon';
import styles from './DataTable.scss';
import InfiniteScroll from '../../utils/InfiniteScroll';
import InfoIcon from '../../InfoIcon';
import { virtualRowsAreEqual, getStickyColumnStyle } from './DataTable.utils';
export var DataTableHeader = function DataTableHeader(props) {
  var dataHook = props.dataHook,
      horizontalScroll = props.horizontalScroll,
      leftShadowVisible = props.leftShadowVisible,
      rightShadowVisible = props.rightShadowVisible,
      stickyColumns = props.stickyColumns;

  var wrapWithHorizontalScroll = function wrapWithHorizontalScroll(table) {
    var _classNames;

    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.scrollWrapper, (_classNames = {}, _defineProperty(_classNames, styles.leftShadowVisible, !!leftShadowVisible), _defineProperty(_classNames, styles.rightShadowVisible, !!rightShadowVisible), _defineProperty(_classNames, styles.withStickyColumns, !!stickyColumns), _classNames))
    }, /*#__PURE__*/React.createElement(ScrollSyncPane, null, table));
  };

  var table = /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    className: classNames(_defineProperty({}, styles.tableHeaderScrollContent, horizontalScroll))
  }, /*#__PURE__*/React.createElement("table", {
    style: {
      width: props.width
    },
    className: styles.table
  }, /*#__PURE__*/React.createElement(TableHeader, props)));
  return horizontalScroll ? wrapWithHorizontalScroll(table) : table;
};
DataTableHeader.propTypes = {
  width: PropTypes.string
};

var DataTable = /*#__PURE__*/function (_React$Component) {
  _inherits(DataTable, _React$Component);

  var _super = _createSuper(DataTable);

  function DataTable(_props) {
    var _this;

    _classCallCheck(this, DataTable);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "_updateScrollShadows", function () {
      var onUpdateScrollShadows = _this.props.onUpdateScrollShadows;

      if (!onUpdateScrollShadows) {
        return;
      }

      var _this$contentRef$curr = _this.contentRef.current,
          scrollLeft = _this$contentRef$curr.scrollLeft,
          scrollWidth = _this$contentRef$curr.scrollWidth,
          clientWidth = _this$contentRef$curr.clientWidth;
      var leftShadowVisible = scrollLeft > 0;
      var rightShadowVisible = scrollWidth - scrollLeft > clientWidth;
      onUpdateScrollShadows(leftShadowVisible, rightShadowVisible);
    });

    _defineProperty(_assertThisInitialized(_this), "wrapWithInfiniteScroll", function (table) {
      return /*#__PURE__*/React.createElement(InfiniteScroll, {
        pageStart: 0,
        loadMore: _this.loadMore,
        hasMore: _this.state.currentPage < _this.state.lastPage || _this.props.hasMore,
        loader: _this.props.loader,
        useWindow: _this.props.useWindow,
        scrollElement: _this.props.scrollElement
      }, table);
    });

    _defineProperty(_assertThisInitialized(_this), "wrapWithHorizontalScroll", function (table) {
      var _classNames3;

      var _this$props = _this.props,
          leftShadowVisible = _this$props.leftShadowVisible,
          rightShadowVisible = _this$props.rightShadowVisible,
          stickyColumns = _this$props.stickyColumns;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(_this.style.scrollWrapper, (_classNames3 = {}, _defineProperty(_classNames3, _this.style.leftShadowVisible, !!leftShadowVisible), _defineProperty(_classNames3, _this.style.rightShadowVisible, !!rightShadowVisible), _defineProperty(_classNames3, _this.style.withStickyColumns, !!stickyColumns), _classNames3))
      }, /*#__PURE__*/React.createElement(ScrollSyncPane, null, table));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTable", function (rowsToRender) {
      var _this$props2 = _this.props,
          dataHook = _this$props2.dataHook,
          showLastRowDivider = _this$props2.showLastRowDivider,
          horizontalScroll = _this$props2.horizontalScroll;
      var style = {
        width: _this.props.width
      };
      return /*#__PURE__*/React.createElement("div", _extends({
        "data-hook": dataHook
      }, horizontalScroll ? {
        className: styles.tableBodyScrollContent,
        ref: _this.contentRef,
        onScroll: _this._updateScrollShadows
      } : undefined), /*#__PURE__*/React.createElement("table", {
        id: _this.props.id,
        style: style,
        className: classNames(_this.style.table, _defineProperty({}, _this.style.showLastRowDivider, showLastRowDivider))
      }, !_this.props.hideHeader && /*#__PURE__*/React.createElement(TableHeader, _this.props), _this.renderBody(rowsToRender)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderBody", function (rows) {
      return /*#__PURE__*/React.createElement("tbody", null, rows.map(function (rowData, index) {
        return _this.renderRow(rowData, index);
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onRowClick", function (rowData, rowNum) {
      var _this$props3 = _this.props,
          onRowClick = _this$props3.onRowClick,
          rowDetails = _this$props3.rowDetails;
      onRowClick && onRowClick(rowData, rowNum);
      rowDetails && _this.toggleRowDetails(rowData);
    });

    _defineProperty(_assertThisInitialized(_this), "renderRow", function (rowData, rowNum, style) {
      var _this$props4 = _this.props,
          onRowClick = _this$props4.onRowClick,
          onMouseEnterRow = _this$props4.onMouseEnterRow,
          onMouseLeaveRow = _this$props4.onMouseLeaveRow,
          rowDataHook = _this$props4.rowDataHook,
          dynamicRowClass = _this$props4.dynamicRowClass,
          isRowHighlight = _this$props4.isRowHighlight,
          rowDetails = _this$props4.rowDetails,
          rowClass = _this$props4.rowClass,
          columns = _this$props4.columns,
          selectedRowsIds = _this$props4.selectedRowsIds,
          isRowSelected = _this$props4.isRowSelected;
      var rowClasses = [rowClass];
      var key = defaultTo(rowData.id, rowNum);
      var optionalRowProps = {};
      var handlers = [{
        rowEventHandler: _this.onRowClick,
        eventHandler: 'onClick'
      }, {
        rowEventHandler: onMouseEnterRow,
        eventHandler: 'onMouseEnter'
      }, {
        rowEventHandler: onMouseLeaveRow,
        eventHandler: 'onMouseLeave'
      }];
      handlers.forEach(function (_ref) {
        var rowEventHandler = _ref.rowEventHandler,
            eventHandler = _ref.eventHandler;

        if (rowEventHandler) {
          optionalRowProps[eventHandler] = function (event) {
            if (event.isDefaultPrevented()) {
              return;
            }

            rowEventHandler(rowData, rowNum);
          };
        }
      });

      if (onRowClick) {
        rowClasses.push(_this.style.clickableDataRow);
      }

      if (rowDetails) {
        rowClasses.push(_this.style.animatedDataRow);
      }

      if (rowDataHook) {
        if (typeof rowDataHook === 'string') {
          optionalRowProps['data-hook'] = rowDataHook;
        } else {
          optionalRowProps['data-hook'] = rowDataHook(rowData, rowNum);
        }
      }

      if (dynamicRowClass) {
        rowClasses.push(dynamicRowClass(rowData, rowNum));
      }

      if (isRowHighlight && isRowHighlight(rowData, rowNum)) {
        rowClasses.push(_this.style.highlight);
      }

      if (isRowSelected ? isRowSelected(rowData, rowNum) : selectedRowsIds && selectedRowsIds.includes(key)) {
        rowClasses.push(_this.style.selected);
      }

      optionalRowProps.className = classNames(rowClasses);
      var rowsToRender = [/*#__PURE__*/React.createElement("tr", _extends({
        "data-table-row": "dataTableRow",
        style: style,
        key: key
      }, optionalRowProps), columns.map(function (column, colNum) {
        return _this.renderCell(rowData, column, rowNum, colNum);
      }))];

      if (rowDetails) {
        var showDetails = !!_this.state.selectedRows.get(rowData);
        rowsToRender.push( /*#__PURE__*/React.createElement("tr", {
          key: "".concat(key, "_details"),
          className: classNames(_this.style.rowDetails)
        }, /*#__PURE__*/React.createElement("td", {
          "data-hook": "".concat(rowNum, "_details"),
          className: classNames(_this.style.details, showDetails ? _this.style.active : ''),
          colSpan: columns.length
        }, /*#__PURE__*/React.createElement("div", {
          className: classNames(_this.style.rowDetailsInner)
        }, /*#__PURE__*/React.createElement(Animator, {
          show: showDetails,
          height: true
        }, rowDetails(rowData, rowNum))))));
      }

      return rowsToRender;
    });

    _defineProperty(_assertThisInitialized(_this), "renderCell", function (rowData, column, rowNum, colNum) {
      var _classNames5;

      var _this$props5 = _this.props,
          virtualized = _this$props5.virtualized,
          stickyColumns = _this$props5.stickyColumns,
          columns = _this$props5.columns;
      var classes = classNames((_classNames5 = {}, _defineProperty(_classNames5, _this.style.important, column.important), _defineProperty(_classNames5, _this.style.largeVerticalPadding, _this.props.rowVerticalPadding === 'large'), _defineProperty(_classNames5, _this.style.mediumVerticalPadding, _this.props.rowVerticalPadding !== 'large'), _defineProperty(_classNames5, _this.style.alignStart, column.align === 'start'), _defineProperty(_classNames5, _this.style.alignCenter, column.align === 'center'), _defineProperty(_classNames5, _this.style.alignEnd, column.align === 'end'), _defineProperty(_classNames5, _this.style.sticky, colNum < stickyColumns), _defineProperty(_classNames5, _this.style.lastSticky, colNum === stickyColumns - 1), _defineProperty(_classNames5, _this.style.stickyActionCell, column.stickyActionCell), _classNames5));
      var width = (virtualized || rowNum === 0) && _this.props.hideHeader ? column.width : undefined;
      var style = typeof column.style === 'function' ? column.style(column, rowData, rowNum) : column.style;
      var stickyColumnStyle = colNum < stickyColumns ? getStickyColumnStyle(columns, column) : undefined;
      return /*#__PURE__*/React.createElement("td", {
        style: _objectSpread(_objectSpread({}, style), stickyColumnStyle),
        width: width,
        className: classes,
        onClick: column.onCellClick ? function (event) {
          return column.onCellClick(column, rowData, rowNum, event);
        } : undefined,
        key: colNum
      }, column.render && column.render(rowData, rowNum));
    });

    _defineProperty(_assertThisInitialized(_this), "calcLastPage", function (_ref2) {
      var data = _ref2.data,
          itemsPerPage = _ref2.itemsPerPage;
      return Math.ceil(data.length / itemsPerPage) - 1;
    });

    _defineProperty(_assertThisInitialized(_this), "loadMore", function () {
      if (_this.state.currentPage < _this.state.lastPage) {
        _this.setState({
          currentPage: _this.state.currentPage + 1
        });
      } else {
        _this.props.loadMore && _this.props.loadMore();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleRowDetails", function (selectedRow) {
      var selectedRows = _this.state.selectedRows;
      var allowMultipleRowDetails = _this.props.allowMultiDetailsExpansion && !_this.props.virtualized;
      var newSelectedRows = new Map([].concat(_toConsumableArray(allowMultipleRowDetails ? _toConsumableArray(selectedRows) : []), [[selectedRow, !selectedRows.get(selectedRow)]]));

      _this.setState({
        selectedRows: newSelectedRows
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderVirtualizedRow", function (_ref3) {
      var data = _ref3.data,
          index = _ref3.index,
          style = _ref3.style;
      return _this.renderRow(data.data[index], index, style)[0];
    });

    _defineProperty(_assertThisInitialized(_this), "renderVirtualizedMemoizedRow", /*#__PURE__*/memo(_this.renderVirtualizedRow, virtualRowsAreEqual));

    _defineProperty(_assertThisInitialized(_this), "getVirtualRowHeight", function () {
      return _this.props.virtualizedLineHeight;
    });

    _defineProperty(_assertThisInitialized(_this), "virtualizedTableElementWithRefForward", /*#__PURE__*/React.forwardRef(function (props, ref) {
      return _this.renderVirtualizedTableElement(_objectSpread(_objectSpread({}, props), {}, {
        ref: ref
      }));
    }));

    _defineProperty(_assertThisInitialized(_this), "renderVirtualizedTableElement", function (_ref4) {
      var children = _ref4.children,
          rest = _objectWithoutProperties(_ref4, ["children"]);

      return /*#__PURE__*/React.createElement("table", rest, /*#__PURE__*/React.createElement(TableHeader, _this.props), children);
    });

    _defineProperty(_assertThisInitialized(_this), "renderVirtualizedTable", function () {
      var _this$props6 = _this.props,
          dataHook = _this$props6.dataHook,
          data = _this$props6.data,
          virtualizedTableHeight = _this$props6.virtualizedTableHeight,
          virtualizedListRef = _this$props6.virtualizedListRef;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook
      }, /*#__PURE__*/React.createElement(List, {
        ref: virtualizedListRef,
        className: classNames(_this.style.table, _this.style.virtualized),
        height: virtualizedTableHeight,
        itemCount: data.length,
        itemData: _this.props,
        width: '100%',
        itemSize: _this.getVirtualRowHeight,
        outerElementType: _this.virtualizedTableElementWithRefForward,
        innerElementType: 'tbody'
      }, _this.renderVirtualizedMemoizedRow));
    });

    var state = {
      selectedRows: new Map()
    };

    if (_props.infiniteScroll) {
      state = _objectSpread(_objectSpread({}, state), _this.createInitialScrollingState(_props));
    }

    _this.state = state;
    _this.contentRef = /*#__PURE__*/React.createRef();

    if (_props.horizontalScroll && 'ResizeObserver' in window) {
      _this.contentResizeObserver = new ResizeObserver(_this._updateScrollShadows);
    }

    return _this;
  }

  _createClass(DataTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var contentResizeObserver = this.contentResizeObserver,
          contentRef = this.contentRef;

      if (contentResizeObserver && contentRef.current) {
        contentResizeObserver.observe(contentRef.current);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var contentResizeObserver = this.contentResizeObserver,
          contentRef = this.contentRef;

      if (contentResizeObserver && contentRef.current) {
        contentResizeObserver.unobserve(contentRef.current);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var isLoadingMore = false;

      if (this.props.infiniteScroll && nextProps.data !== this.props.data) {
        if (nextProps.data instanceof Array && this.props.data instanceof Array) {
          isLoadingMore = true;
          var lastPage = this.calcLastPage(nextProps);
          var currentPage = this.state.currentPage < lastPage ? this.state.currentPage + 1 : this.state.currentPage;
          this.setState({
            lastPage: lastPage,
            currentPage: currentPage
          });
        }

        if (!isLoadingMore) {
          this.setState(this.createInitialScrollingState(nextProps));
        }
      }
    }
  }, {
    key: "createInitialScrollingState",
    value: function createInitialScrollingState(props) {
      return {
        currentPage: 0,
        lastPage: this.calcLastPage(props)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          virtualized = _this$props7.virtualized,
          data = _this$props7.data,
          showHeaderWhenEmpty = _this$props7.showHeaderWhenEmpty,
          horizontalScroll = _this$props7.horizontalScroll,
          infiniteScroll = _this$props7.infiniteScroll,
          itemsPerPage = _this$props7.itemsPerPage;

      if (!data.length && !showHeaderWhenEmpty) {
        return null;
      }

      if (virtualized) {
        return this.renderVirtualizedTable(data);
      }

      var rowsToRender = infiniteScroll ? data.slice(0, (this.state.currentPage + 1) * itemsPerPage) : data;
      var table = this.renderTable(rowsToRender);

      if (horizontalScroll) {
        table = this.wrapWithHorizontalScroll(table);
      }

      if (infiniteScroll) {
        table = this.wrapWithInfiniteScroll(table);
      }

      return table;
    }
  }, {
    key: "style",
    get: function get() {
      return styles;
    }
  }]);

  return DataTable;
}(React.Component);

var TableHeader = /*#__PURE__*/function (_Component) {
  _inherits(TableHeader, _Component);

  var _super2 = _createSuper(TableHeader);

  function TableHeader() {
    var _this2;

    _classCallCheck(this, TableHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "renderSortingArrow", function (sortDescending, colNum) {
      if (sortDescending === undefined) {
        return null;
      }

      var Arrow = sortDescending ? SortByArrowDown : SortByArrowUp;
      return /*#__PURE__*/React.createElement("span", {
        "data-hook": "".concat(colNum, "_title"),
        className: _this2.style.sortArrow
      }, /*#__PURE__*/React.createElement(Arrow, {
        height: 12,
        "data-hook": sortDescending ? 'sort_arrow_dec' : 'sort_arrow_asc'
      }));
    });

    _defineProperty(_assertThisInitialized(_this2), "renderInfoTooltip", function (tooltipProps, colNum) {
      if (tooltipProps === undefined) {
        return null;
      }

      var content = tooltipProps.content,
          otherTooltipProps = _objectWithoutProperties(tooltipProps, ["content"]);

      return /*#__PURE__*/React.createElement(InfoIcon, {
        content: content,
        tooltipProps: otherTooltipProps,
        dataHook: "".concat(colNum, "_info_tooltip"),
        className: _this2.style.infoTooltipWrapper
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "renderHeaderCell", function (column, colNum) {
      var _classNames6, _classNames7;

      var _this2$props = _this2.props,
          stickyColumns = _this2$props.stickyColumns,
          columns = _this2$props.columns;
      var stickyColumnStyle = colNum < stickyColumns ? getStickyColumnStyle(columns, column) : undefined;

      var style = _objectSpread({
        width: column.width,
        padding: _this2.props.thPadding,
        height: _this2.props.thHeight,
        fontSize: _this2.props.thFontSize,
        border: _this2.props.thBorder,
        boxShadow: _this2.props.thBoxShadow,
        color: _this2.props.thColor,
        opacity: _this2.props.thOpacity,
        letterSpacing: _this2.props.thLetterSpacing,
        cursor: column.sortable === undefined ? 'auto' : 'pointer'
      }, stickyColumnStyle);

      var optionalHeaderCellProps = {};

      if (column.sortable) {
        optionalHeaderCellProps.onClick = function () {
          return _this2.props.onSortClick && _this2.props.onSortClick(column, colNum);
        };
      }

      return /*#__PURE__*/React.createElement("th", _extends({
        style: style,
        key: colNum,
        className: classNames(_this2.style.thText, (_classNames6 = {}, _defineProperty(_classNames6, _this2.style.thSkinStandard, !_this2.props.skin || _this2.props.skin === 'standard'), _defineProperty(_classNames6, _this2.style.thSkinNeutral, _this2.props.skin === 'neutral'), _defineProperty(_classNames6, _this2.style.sticky, colNum < stickyColumns), _defineProperty(_classNames6, _this2.style.lastSticky, colNum === stickyColumns - 1), _classNames6))
      }, optionalHeaderCellProps), /*#__PURE__*/React.createElement("div", {
        className: classNames(_this2.style.thContainer, (_classNames7 = {}, _defineProperty(_classNames7, _this2.style.alignStart, !column.align || column.align === 'start'), _defineProperty(_classNames7, _this2.style.alignCenter, column.align === 'center'), _defineProperty(_classNames7, _this2.style.alignEnd, column.align === 'end'), _classNames7))
      }, column.title, _this2.renderSortingArrow(column.sortDescending, colNum), _this2.renderInfoTooltip(column.infoTooltipProps, colNum)));
    });

    return _this2;
  }

  _createClass(TableHeader, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, this.props.columns.map(this.renderHeaderCell)));
    }
  }, {
    key: "style",
    get: function get() {
      return styles;
    }
  }]);

  return TableHeader;
}(Component);

_defineProperty(TableHeader, "propTypes", {
  onSortClick: PropTypes.func,
  thPadding: PropTypes.string,
  thHeight: PropTypes.string,
  thFontSize: PropTypes.string,
  thBorder: PropTypes.string,
  thColor: PropTypes.string,
  thOpacity: PropTypes.string,
  thLetterSpacing: PropTypes.string,
  thBoxShadow: PropTypes.string,
  columns: PropTypes.array,
  skin: PropTypes.oneOf(['standard', 'neutral']),
  leftShadowVisible: PropTypes.bool,
  rightShadowVisible: PropTypes.bool
});

function validateData(props, propName) {
  if (props[propName]) {
    if (props[propName].constructor && props[propName].constructor.name && props[propName].constructor.name.toLowerCase().indexOf('array') > -1) {
      return null;
    } else {
      return Error('Data element must be an array type');
    }
  }

  return null;
}

DataTable.defaultProps = {
  data: [],
  columns: [],
  selectedRowsIds: [],
  isRowSelected: null,
  showHeaderWhenEmpty: false,
  infiniteScroll: false,
  itemsPerPage: 20,
  width: '100%',
  loadMore: null,
  hasMore: false,
  loader: /*#__PURE__*/React.createElement("div", {
    className: "loader"
  }, "Loading ..."),
  scrollElement: null,
  useWindow: true,
  rowVerticalPadding: 'medium',
  showLastRowDivider: true,
  virtualizedLineHeight: 60,
  skin: 'standard',
  horizontalScroll: false,
  stickyColumns: 0
};
DataTable.propTypes = {
  dataHook: PropTypes.string,

  /** An id to pass to the table */
  id: PropTypes.string,

  /** The data to display. (If data.id exists then it will be used as the React key value for each row, otherwise, the rowIndex will be used) */
  data: validateData,

  /** Configuration of the table's columns. See table below */
  columns: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    render: PropTypes.func.isRequired,
    sortable: PropTypes.bool,
    infoTooltipProps: PropTypes.shape(TooltipCommonProps),
    sortDescending: PropTypes.bool,
    align: PropTypes.oneOf(['start', 'center', 'end']),
    important: PropTypes.bool,
    style: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    stickyActionCell: PropTypes.bool
  })).isRequired,

  /** Should the table show the header when data is empty */
  showHeaderWhenEmpty: PropTypes.bool,

  /** A string data-hook to apply to all table body rows. or a func which calculates the data-hook for each row  - Signature: `(rowData, rowNum) => string` */
  rowDataHook: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  /** A class to apply to all table body rows */
  rowClass: PropTypes.string,

  /** A func that gets row data and returns a class(es) to apply to that specific row */
  dynamicRowClass: PropTypes.func,

  /** A func that gets row data and returns boolean if row is selected or not */
  isRowSelected: PropTypes.func,

  /** A func that gets row data and returns boolean if row is highlighted or not */
  isRowHighlight: PropTypes.func,

  /** A callback method to be called on row click. Signature: `onRowClick(rowData, rowNum)` */
  onRowClick: PropTypes.func,

  /** A callback method to be called on row mouse enter. Signature: `onMouseEnterRow(rowData, rowNum)` */
  onMouseEnterRow: PropTypes.func,

  /** A callback method to be called on row mouse leave. Signature: `onMouseLeaveRow(rowData, rowNum)` */
  onMouseLeaveRow: PropTypes.func,

  /** If true, table will not render all data to begin with, but will gradually render the data as the user scrolls */
  infiniteScroll: PropTypes.bool,

  /** If infiniteScroll is on, this prop will determine how many rows will be rendered on each load */
  itemsPerPage: PropTypes.number,

  /** The width of the fixed table. Can be in percentages or pixels. */
  width: PropTypes.string,

  /** Table styling. Supports `standard` and `neutral`. */
  skin: PropTypes.oneOf(['standard', 'neutral']),

  /** A callback when more items are requested by the user. */
  loadMore: PropTypes.func,

  /** Whether there are more items to be loaded. Event listeners are removed if false. */
  hasMore: PropTypes.bool,

  /** The loader to show when loading more items. */
  loader: PropTypes.node,

  /** Add scroll listeners to the window, or else, the component's parentNode. */
  useWindow: PropTypes.bool,

  /** Add scroll listeners to specified DOM Object. */
  scrollElement: PropTypes.object,

  /** Table cell vertical padding. should be 'medium' or 'large'  */
  rowVerticalPadding: PropTypes.oneOf(['medium', 'large']),

  /** this prop is deprecated and should not be used
   * @deprecated
   */
  thPadding: PropTypes.string,

  /** this prop is deprecated and should not be used
   * @deprecated
   */
  thHeight: PropTypes.string,

  /** this prop is deprecated and should not be used
   * @deprecated
   */
  thFontSize: PropTypes.string,

  /** this prop is deprecated and should not be used
   * @deprecated
   */
  thBorder: PropTypes.string,

  /** this prop is deprecated and should not be used
   * @deprecated
   */
  thColor: PropTypes.string,

  /** this prop is deprecated and should not be used
   * @deprecated
   */
  thOpacity: PropTypes.string,

  /** this prop is deprecated and should not be used
   * @deprecated
   */
  thBoxShadow: PropTypes.string,

  /** this prop is deprecated and should not be used
   * @deprecated
   */
  thLetterSpacing: PropTypes.string,

  /** Function that returns React component that will be rendered in row details section. Example: `rowDetails={(row, rowNum) => <MyRowDetailsComponent {...row} />}` */
  rowDetails: PropTypes.func,

  /** Allows to open multiple row details */
  allowMultiDetailsExpansion: PropTypes.bool,

  /** Should we hide the header of the table. */
  hideHeader: PropTypes.bool,

  /** A flag specifying weather to show a divider after the last row */
  showLastRowDivider: PropTypes.bool,

  /** ++EXPERIMENTAL++ virtualize the table scrolling for long list items */
  virtualized: PropTypes.bool,

  /** ++EXPERIMENTAL++ Set virtualized table height */
  virtualizedTableHeight: PropTypes.number,

  /** ++EXPERIMENTAL++ Set virtualized table row height */
  virtualizedLineHeight: PropTypes.number,

  /** ++EXPERIMENTAL++ Set ref on virtualized List containing table rows */
  virtualizedListRef: PropTypes.any,

  /** array of selected ids in the table. Note that `isRowSelected` prop provides greater selection logic flexibility and is recommended to use instead. */
  selectedRowsIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),

  /** A callback function called on each column title click. Signature `onSortClick(colData, colNum)` */
  onSortClick: PropTypes.func,

  /* Horizontal scroll support props. */
  horizontalScroll: PropTypes.bool,
  stickyColumns: PropTypes.number,
  leftShadowVisible: PropTypes.bool,
  rightShadowVisible: PropTypes.bool,
  onUpdateScrollShadows: PropTypes.func
};
DataTable.displayName = 'DataTable';
export default DataTable;